// extracted by mini-css-extract-plugin
export default {"preloader":"feed_preloader__IR9RD"};